import { TicketsBookInput } from '@/types/tickets';
import { apiPaymentsUrl } from '@/utils/constants';

export async function bookTickets(input: TicketsBookInput) {
    const urlParams = new URLSearchParams();
    urlParams.set('event_id', input.event_id);
    urlParams.set('customer_email', input.customer_email);
    urlParams.set('customer_first_name', input.customer_first_name);
    urlParams.set('customer_last_name', input.customer_second_name);
    urlParams.set('country_code', input.country_code.toLowerCase());
    urlParams.set('payment_provider', input.payment_provider);
    input.customer_telegram && urlParams.set('customer_telegram', input.customer_telegram);
    input.coupon_code && urlParams.set('coupon_code', input.coupon_code);
    input.customer_address && urlParams.set('customer_address', input.customer_address);
    urlParams.set('customer_phone', input.customer_phone);

    const queryString = decodeURI(urlParams.toString());

    const url = `${apiPaymentsUrl}/api/tickets/book_tickets?${queryString}`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'accept-language': input.language,
        },
        body: JSON.stringify(input.body),
    });
    return await response.json();
}

export async function checkCoupon(event_id: string, coupon_code: string) {
    const url = `${apiPaymentsUrl}/api/tickets/check_coupon?coupon_code=${coupon_code}&event_id=${event_id}`;
    return await fetch(url).then((res) => res.json());
}

export async function checkEmail(email: string) {
    const emailStr = `customer_email=${encodeURIComponent(email)}`;
    const url = `${apiPaymentsUrl}/api/tickets/check_email?${emailStr}`;
    return await fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' } }).then((res) =>
        res.json(),
    );
}

export async function sentTransaction({ transaction_id, amount }: { transaction_id: string; amount: number }) {
    return await fetch('/api/tool-hub/feedback/send-transaction', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ transaction_id, amount }),
    });
}
